import { render, staticRenderFns } from "./text-diff.vue?vue&type=template&id=07f284e3"
import script from "./text-diff.vue?vue&type=script&lang=ts"
export * from "./text-diff.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports